const labSection = document.querySelectorAll('.lab-offer');

if (labSection && labSection.length > 0) {
    let sectionLabItemsProperties = [];
    const windowWidth = 991.98;

    const handleSectionLabItemProperties = () => {
        labSection.forEach((section, key) => {
            const itemLabImage = section.querySelector(
                '.lab-offer__item-image'
            );
            const fillItem = section.querySelector('.lab-offer__item-fill');
            const servicesButtons = section.querySelectorAll(
                '.lab-offer__single-service-button'
            );
            const servicesButtonsLength = servicesButtons.length;
            itemLabHeight = itemLabImage.offsetHeight;
            itemLabFillPart =
                (itemLabHeight * 0.8) / (servicesButtonsLength + 1);

            sectionLabItemsProperties[key] = {
                itemLabHeight: itemLabHeight,
                itemLabFillPart: itemLabFillPart,
                fillItem: fillItem,
            };
        });
    };

    if (window.innerWidth > windowWidth) {
        handleSectionLabItemProperties();
    }

    window.addEventListener('resize', () => {
        if (window.innerWidth > windowWidth) {
            handleSectionLabItemProperties();
        }
    });

    const unactiveAllSectionServices = (section, key) => {
        const services = section.querySelectorAll('.lab-offer__single-service');

        setFill(key);

        if (services && services.length > 0) {
            services.forEach(service => service.classList.remove('active'));
        }
    };

    const setFill = (key, times = 1) => {
        if (window.innerWidth > windowWidth) {
            const labItem = sectionLabItemsProperties[key];

            if (labItem) {
                const { fillItem, itemLabFillPart } = labItem;

                fillItem.style.height = `${itemLabFillPart * times}px`;
            }
        }
    };

    const handleServiceClick = (e, section, sectionKey, serviceButtonKey) => {
        const { currentTarget } = e;
        const parentElement = currentTarget.parentElement;

        if (!parentElement.classList.contains('active')) {
            unactiveAllSectionServices(section, sectionKey);
            parentElement.classList.add('active');
            setFill(sectionKey, serviceButtonKey + 2);
        } else {
            setFill(sectionKey);
            parentElement.classList.remove('active');
        }
    };

    labSection.forEach((section, key) => {
        const servicesButtons = section.querySelectorAll(
            '.lab-offer__single-service-button'
        );
        const servicesButtonsLength = servicesButtons.length;

        unactiveAllSectionServices(section, key);
        if (window.innerWidth < windowWidth && servicesButtons.length > 0) {
            servicesButtons[0].parentElement.classList.add('active');
        }

        window.addEventListener('resize', () => {
            unactiveAllSectionServices(section, key);
            if (window.innerWidth < windowWidth && servicesButtons.length > 0) {
                servicesButtons[0].parentElement.classList.add('active');
            }
        });

        if (servicesButtons && servicesButtonsLength > 0) {
            servicesButtons.forEach((button, serviceButtonKey) =>
                button.addEventListener('click', e =>
                    handleServiceClick(e, section, key, serviceButtonKey)
                )
            );
        }
    });
}
